import React from 'react';
import InfiniteScroll from "react-infinite-scroll-component";
import { ArrowBackHoc, loaderSVG, MailIconHoc, EmptySearchHoc } from '../../assets/images';
import "../../assets/scss/minEmoji.scss";
import { getHighlightedText, getValidSearchVal, handleFilterBlockedContact } from '../../Helpers/Utility.js';
import UserStatus from './Common/UserStatus.js';
import { getContactNameFromRoster } from '../../Helpers/Chat/User.js';
import { NO_SEARCH_CONTACT_FOUND } from '../../processENV';
import ImageComponent from '../Common/ImageComponent';
import WebChatSearch from './WebChatSearch';
import { useSelector } from 'react-redux';
import { getUsersListFromSDK } from './RecentChatSection/userLists';
import { store } from '../../Redux/store';
import { addActiveChatData } from '../../Redux/feature/activeChatDataSlice';
import { setInitialRoster } from '../../Redux/feature/rosterDataSlice';
import { isUserWhoBlockedMe } from '../../Helpers/Chat/BlockContact';

const WebChatRoster = (props = {}) => {
    const {newChatStatus = false , handleBackStatus = () => {}} = props;
    const globalState = useSelector(state => state)
    const { rosterData = {}, dynamicIcon = {},recentChatItems } = globalState;
    const { mf_loader } = dynamicIcon?.data;
    /**
     * Following the states used in WebChatRoster Component.
     *
     * @param {boolean} loaderStatus Display the loader based on the loaderStatus state.
     * @param {array} filterItem Manage the search items in this state.
     */
    const [webChatRosterState, setWebChatRosterState] = React.useState({
        loaderStatus: rosterData?.isFetchingUserList,
        filterItem: [],
        userList: [],
        searchIn: "contacts",
        searchWith: ""
    });


    const {
        loaderStatus,
        filterItem,
        userList,
        searchIn,
        searchWith,
    } = webChatRosterState;

    /**
     * handleOnBack() method to manage the back to recent chat icon click status.
     */
    const handleOnBack = () => {
        handleBackStatus(true);
    }

    const handleRoster = (event, response) => {
        let data = {
            chatId:response?.userId,
            chatJid:response?.userJid,
            chatType: "chat",
            roster: response,
            recent: {
                chatType: "chat"
            }
        }
        /**
        // Store.dispatch(chatResetMessage()).then(() => {
        //     data.chatType = "chat";
        //     data.chatId = response.userId;
        //     data.chatJid = formatUserIdToJid(response.userId);
        //     Store.dispatch(ActiveChatAction(data));
        //     this.props.handleBackStatus(true);
        // })
        */
        store.dispatch(addActiveChatData(data))
        handleOnBack()
    }

    /**
     * handleMobileContacts() to display the mobile contacts in new chat.
     *
     * @param {object} roster
     */
    const handleMobileContacts = (roster) => {
        let isBlocked = isUserWhoBlockedMe(roster.userId);;
        let displayContactName = getContactNameFromRoster(roster);
        return (
            <li className={`chat-list-li`} key={roster.userId}
                onClick={(e) => handleRoster(e, roster)}>
                <div className="profile-image">
                    <div className="image">
                        <ImageComponent
                            chatType={'chat'}
                            blocked={isBlocked}
                            temporary={false}
                            imageToken={roster.thumbImage !== "" ? roster.thumbImage : roster.image}
                            // name={displayContactName}
                        />
                    </div>
                </div>
                <div className="recentchats">
                    <div className="recent-username-block">
                        <div className="recent-username">
                            <div className="username">
                                <h3 title={displayContactName}>
                                    <span>
                                        {searchWith !== "" ?
                                            getHighlightedText(displayContactName, searchWith) :
                                            displayContactName
                                        }
                                    </span>
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div className="recent-message-block">
                        <UserStatus status={roster.status} blocked={isBlocked} userId={roster.userId} />
                    </div>
                </div>
            </li>
        )
    }

    /**
     * handleEmailContacts() method to display the email contacts in new chat.
     * @param {object} roster
     */
    const handleEmailContacts = (roster) => {
        let isBlocked = isUserWhoBlockedMe(roster.userId);;
        let displayContactName = getContactNameFromRoster(roster);

        return <li className={`chat-list-li ${isBlocked ? "Blocked" : ""}`} key={roster.userId} onClick={(e) => handleRoster(e, roster)}>
            <div className="profile-image">
                <div className="image">
                    <ImageComponent
                        chatType={'chat'}
                        blocked={isBlocked}
                        temporary={false}
                        imageToken={roster.thumbImage !== "" ? roster.thumbImage : roster.image}
                        // name={displayContactName}
                    />
                </div>
                <i>
                    <MailIconHoc viewBox="0 0 14 14" />
                </i>
            </div>
            <div className="recentchats">
                <div className="recent-username-block">
                    <div className="recent-username">
                        <div className="username">
                            <h3 title={displayContactName}>
                                {searchWith !== "" ?
                                    getHighlightedText(displayContactName, searchWith) :
                                    displayContactName
                                }
                            </h3>
                        </div>
                    </div>
                </div>
                <div className="recent-message-block">
                    <UserStatus status={roster.status} blocked={isBlocked} userId={roster.userId} />
                </div>
            </div>
        </li>
    }

    /**
     * handleUpdateRoster() method handles if roster dynamic update in search result.
     */
    const handleUpdateRoster = (rosterDataUpdate, isFetchingUserList = false) => {
        let searchWithUpdate = webChatRosterState.searchWith;
        let filteredData = handleFilterBlockedContact(rosterDataUpdate).filter(function (item) {
            let filterVariable = getContactNameFromRoster(item) || item.userId;
            return (item.isFriend) && filterVariable.toLowerCase().search(searchWithUpdate.toLowerCase()) !== -1;
        });
        let data = filteredData
        /**
        // if(data.length === 0){
        //     isFetchingUserList = true
        // }
        */
        setWebChatRosterState({ ...webChatRosterState, filterItem: data, userList: data, loaderStatus: isFetchingUserList });
    }

    /**
     * componentDidUpdate() is one of the react lifecycle method. <br />
     * In this method, to updated the upcoming rosters into state.
     *
     * @param {object} prevProps
     * @param {object} prevState
     */

    React.useEffect(()=>{
        getUsersListFromSDK(1,"")
        store.dispatch(setInitialRoster())
    },[])

    React.useEffect(() => {
        let data = (rosterData && rosterData.data) || []
        if(!rosterData?.initialRosterFetched){
            getUsersListFromSDK(1,"")
            handleUpdateRoster(data, rosterData?.isFetchingUserList);
        }
    }, [])

    React.useEffect(() => {
            handleUpdateRoster(rosterData.data, rosterData?.isFetchingUserList);
    }, [rosterData, recentChatItems])

    /**
     * handleFilterContactsList() method is to handle the searched contacts from list
     *
     * @param {string} searchWith
     */
    const handleFilterContactsList = (searchWithContact) => {
        setWebChatRosterState({ ...webChatRosterState, searchWith: searchWithContact });
    }

    const fetchMoreData = () => {
        let userListArrFetch = userList;
        getUsersListFromSDK(Math.ceil((userListArrFetch.length / 20) + 1), getValidSearchVal(webChatRosterState.searchWith));
    }

    const handleUserListData = () => {
        let dataArr = [];   
        if (filterItem.length > 0 && userList.length > 0) {
            userList.map((roster, index) => {
                dataArr.push(
                    <React.Fragment key={roster.userId}>
                        {roster.emailId ? handleEmailContacts(roster) : handleMobileContacts(roster)}
                    </React.Fragment>
                )
            });
        } else if (filterItem.length === 0 && searchWith !== "") {
            dataArr.push(
                <div key="0" className="no-search-record-found">
                    <div className="norecent-chat">
                        <i className="norecent-chat-img">
                            <EmptySearchHoc />
                        </i>
                        <h4>{NO_SEARCH_CONTACT_FOUND} </h4>
                    </div>
                </div>
            );
        }
        return dataArr;
    }
    const userListArr = handleUserListData();

    return (
        <React.Fragment>
            <div style={{ display: newChatStatus ? 'none' : '' }} className="contactlist">
                <div className="recent-chatlist-header">
                    <div className="profile-img-name">
                        <i className="newchat-icon" onClick={handleOnBack} title="Back">
                            <ArrowBackHoc viewBox="0 0 24 24"/>
                        </i>
                        <span>{"New chat"}</span>
                    </div>
                </div>
                <WebChatSearch searchIn={searchIn} handleSearchFilterList={handleFilterContactsList} />
                {loaderStatus && <div className="loader-container style-2">
                    <img src={ mf_loader ? mf_loader : loaderSVG } alt="loader" />
                </div>}

                {userListArr.length > 0 &&
                    <ul className="chat-list-ul" id="scrollableUl">
                        <InfiniteScroll
                            dataLength={userListArr.length}
                            next={fetchMoreData}
                            hasMore={true}
                            scrollableTarget="scrollableUl"
                        >
                            {handleUserListData()}
                        </InfiniteScroll>
                    </ul>
                }
            </div>
        </React.Fragment>
    );
};


export default WebChatRoster;
